import classNames from "classnames";
import styles from "./avatar.module.scss";
import { useMemo } from "react";
import SvgIcon from "@/components/common/SvgIcon";
import Typography, { TTypographyProps } from "../Typography";

type TProps = {
  name?: string;
  src?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "xll";
  className?: string;
  displayedWordAmount?: number;
  fontFamily?: TTypographyProps["variant"];
  style?: React.CSSProperties;
};

const Avatar = ({
  src,
  name,
  size = "md",
  className,
  displayedWordAmount = 1,
  fontFamily = "Body2-Light",
  style,
}: TProps) => {
  const defaultName = useMemo(() => {
    if (!name) return undefined;
    const splitted = name?.trim()?.split(" ") || [];
    return splitted
      .slice(0, displayedWordAmount)
      .map((word) => word[0] || "")
      .join("")
      .toUpperCase();
  }, [name, displayedWordAmount]);

  return src ? (
    <img
      alt=""
      className={classNames(
        `rounded-full object-cover ${styles[size]}`,
        className,
      )}
      src={src}
    />
  ) : (
    <div
      className={classNames(`${styles.avatar} ${styles[size]}`, className)}
      style={style}
    >
      {defaultName && (
        <Typography variant={fontFamily}>{defaultName}</Typography>
      )}
      {!defaultName && (
        <SvgIcon
          iconName="user-solid"
          className="rounded-[16px] mt-[4px]"
          fill="fill-gray-200"
        />
      )}
    </div>
  );
};

export default Avatar;
